import { createAction, props } from '@ngrx/store';
import { CreateTimeBasedWorkPropositionRequest } from '../../models/requests/create-time-based-work-proposition-request';
import { UpdateTimeBasedWorkPropositionRequest } from '../../models/requests/update-time-based-work-proposition-request';
import { TimeBasedWorkProposition } from '../../models/time-based-work-proposition.model';

// Load actions
export const loadTimeBasedWorkProposition = createAction(
  '[TimeBasedWorkProposition] Load Time Based Work Proposition',
  props<{ ruleUid: string | undefined }>()
);
export const loadTimeBasedWorkPropositionSuccess = createAction(
  '[TimeBasedWorkProposition] Load Time Based Work Proposition Success',
  props<{ timeBasedWorkProposition: TimeBasedWorkProposition[] }>()
);
export const loadTimeBasedWorkPropositionFailure = createAction(
  '[TimeBasedWorkProposition] Load Time Based Work Proposition Failure',
  props<{ error: any }>()
);

// Delete actions
export const deleteMultipleTimeBasedWorkPropositions = createAction(
  '[TimeBasedWorkProposition] Delete Multiple Time Based Work Propositions',
  props<{ uids: string[] }>()
);
export const deleteMultipleTimeBasedWorkPropositionsSuccess = createAction(
  '[TimeBasedWorkProposition] Delete Multiple Time Based Work Propositions Success',
  props<{ uids: string[] }>()
);
export const deleteMultipleTimeBasedWorkPropositionsFailure = createAction(
  '[TimeBasedWorkProposition] Delete Multiple Time Based Work Propositions Failure',
  props<{ error: any }>()
);

// Create actions
export const createMultipleTimeBasedWorkPropositions = createAction(
  '[TimeBasedWorkProposition] Create Multiple Time Based Work Propositions',
  props<{ requests: CreateTimeBasedWorkPropositionRequest[] }>()
);
export const createMultipleTimeBasedWorkPropositionsSuccess = createAction(
  '[TimeBasedWorkProposition] Create Multiple Time Based Work Propositions Success',
  props<{ timeBasedWorkPropositions: TimeBasedWorkProposition[] }>()
);
export const createMultipleTimeBasedWorkPropositionsFailure = createAction(
  '[TimeBasedWorkProposition] Create Multiple Time Based Work Propositions Failure',
  props<{ error: any }>()
);

// Update actions
export const updateMultipleTimeBasedWorkPropositions = createAction(
  '[TimeBasedWorkProposition] Update Multiple Time Based Work Propositions',
  props<{ requests: UpdateTimeBasedWorkPropositionRequest[] }>()
);
export const updateMultipleTimeBasedWorkPropositionsSuccess = createAction(
  '[TimeBasedWorkProposition] Update Multiple Time Based Work Propositions Success',
  props<{ timeBasedWorkPropositions: TimeBasedWorkProposition[] }>()
);
export const updateMultipleTimeBasedWorkPropositionsFailure = createAction(
  '[TimeBasedWorkProposition] Update Multiple Time Based Work Propositions Failure',
  props<{ error: any }>()
);
